import { render, staticRenderFns } from "./CommentDialog.vue?vue&type=template&id=d6b63b60&scoped=true"
import script from "./CommentDialog.vue?vue&type=script&lang=js"
export * from "./CommentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b63b60",
  null
  
)

export default component.exports